// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"styles__breadcrumbs___tItxC","focus-visible":"styles__focus-visible___Ri2FL","skeleton":"styles__skeleton___auNxj"};